export const BLEMISH_COLOR = {
    Red: '#c00',
    Amber: '#ffa500',
    Green: '#87d068',
};



// WEBPACK FOOTER //
// ./src/modules/Leads/constants/blemish_color.constats.js